<template>
	<div id="contact-view" v-show="showContact" @click.stop="close">
		<div class="canvas" @click.stop="stop">
			<button class="close-contact" @click.stop="close"><i class="ion-close"></i></button>
			<img class="image" style="object-fit:contain" :src="`/files-large/${image}`" :alt="name"/>
			<div class="content">
				<div class="content-wrapper">
					<h2 style="color: rgb(254, 165, 32);font-weight:600">{{ name }}</h2>
					<div class="title" v-html="title"></div>
					<div v-if="isHTMLTitleLong" class="prof-description" v-html="title_long"></div>
					<div v-else class="prof-description" v-html="markdown(title_long)"></div>
					<button v-if="contact.linkedin" class="linkedin" @click="linkedin"><i class="ion-social-linkedin"></i> Linkedin</button>
				</div>
			</div>
		</div>
	</div>
</template>

<script>

	import marked from 'marked';

	export default {
		props: {
			contact: {
				type: Object,
				default: {}
			}
		},
		computed: {
			// ...mapState({
			// 	show: 'showContact'
			// })
			image() {
				return this.contact.large || this.contact.small;
			},
			showContact() {
				return this.contact.first_name || this.contact.last_name;
			},
			name() {
				return this.lang === 'hu'
					? this.contact.last_name + ' ' + this.contact.first_name
					: this.contact.first_name + ' ' + this.contact.last_name;
			},
			title() {
				return this.contact['title_' + this.lang] || this.contact.title_en;
			},
			title_long() {
				return this.contact['title_long_' + this.lang] || this.contact.title_long_en;
			},
			lang() {
				return this.$route.params.lang;
			},
			isHTMLTitleLong(){
				if (!this.title_long) return true;
				return this.title_long.indexOf('<p>') > -1
			}
		},
		methods: {
			markdown(source) {
			    marked.setOptions({
			        renderer: new marked.Renderer(),
			        gfm: true,
			        tables: true,
			        breaks: true,
			        pedantic: false,
			        sanitize: true,
			        smartLists: true,
			        smartypants: false
			    });
			    return marked(source || '');
			},
			close() {
				document.body.classList.remove('hide-overflow');
				this.$emit('close');
			},
			handleKeyEvent(event) {
				if(event.keyCode === 27) this.$emit('close');
			},
			stop() {
				// console.log('stop');
			},
			linkedin() {
				window.open(this.contact.linkedin);
			}
		},
		mounted() {
			window.addEventListener('keyup', this.handleKeyEvent);
		},
		data() {
			return {}
		}
	}
</script>

<style lang="scss" scoped>

	@import './../../sass/variables';

	#contact-view {
		background-color: rgba($light-blue, 0.5);
		position: fixed;
		padding: 50px;
		z-index: 1000;
		height: 100vh;
		width: 100vw;
		left: 0;
		top: 0;

		@media screen and (max-width: $tablet-max) {
			padding: 20px;
		}

		.canvas {
			background-color: #fff;
			position: relative;
			display: block;
			height: 100%;
			padding: 0;

			@media screen and (max-width: $tablet-max) {
				flex-direction: column;
				display: flex;
				padding: 0;
			}


			.image {
				background-repeat: no-repeat;
				background-position: center;
				background-size: contain;
				position: absolute;
				display: block;
				height: 100%;
				z-index: 1;
				width: 40%;
				left: 0;
				top: 0;

				@media screen and (max-width: $tablet-max) {
					position: relative;
					// max-height: 40vh;
					// min-height: 80vw;
					height: initial;
				    flex: 0 0 70vw;
					width: 100%;
				}
			}

			.content {
				overflow-x: hidden;
				overflow-y: scroll;
				position: relative;
				margin-left: 40%;
				height: 100%;

				@media screen and (max-width: $tablet-max) {
					height: initial;
					margin-left: 0;
					flex: 0 1 auto;
					margin-top: 0;
					width: 100%;
				}

				.content-wrapper {
					padding: 20px;

					@media screen and (max-width: $tablet-max) {
						padding: 20px;
					}
				}

				h2 {
					margin-bottom: 45px;
					font-weight: normal;

					span {
						font-weight: bold;
						color: $blue;
					}
				}

				.title {
					font-weight: bold;
					margin-bottom: 20px;
          color: rgb(36, 68, 115);
				}

				.prof-description {
					margin-bottom: 20px;
				}

				a.email {
					text-decoration: none;
					display: inline-block;
					margin-right: 15px;
					color: $light-blue;
					font-size: 18px;
				}

				p {
					font-size: 18px;
				}
			}
		}
	}

	.linkedin {
		background-color: $linkedin;
		display: inline-block;
		border-radius: 4px;
		border: none;
		color: #fff;

		i {
			color: #fff;
		}
	}

	.close-contact {
		background-color: transparent;
		color: lighten(#000, 90%);
		position: absolute;
		line-height: 40px;
		font-size: 40px;
		border: none;
		height: 40px;
		width: 40px;
		right: 20px;
		z-index: 10;
		top: 20px;

		&:hover {
			color: $black;
		}
	}

</style>
